
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import { useAuthState } from '../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { WTPLocationMasterDDL } from '../../../../../Components/CommonDDL/WTPLocationMasterDDL'
import moment from 'moment'
import { WTPOperationalWorkDeleteAPI, WTPOperationalWorkTableDataAPI, WTPOperationalWorkTableExportDataAPI } from '../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/PreventiveData/OperationalWorkSlice'
import { Loading } from '../../../../../Helper/Loading'
import DeletePopup from '../../GardenPopup/DeletePopup'
import ViewURL from '../../../../../Components/ViewURL/ViewURL'
import { Pegination } from '../../../../../Components/Pegination/Pegination'
import { WTPPreventiveOperationalWorkExportData } from './WTPPreventiveOperationalWorkExport'


export default function WTPPreventiveOperationalWorkPage() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [ExportData, setExportData] = useState([])
    const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [Heading, setHeading] = React.useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [DeletePopupShow, setDeletePopupShow] = useState()

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const [LocationName, setLocationName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)

    }

    const handleClear = () => {
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        setLocationName({
            ...LocationName,
            ID: 0,
            Label: 'Select...',
        })
        setFromDate('')
        setToDate('')
    }

    useEffect(() => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_WTP_LocationID: LocationName.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handleGetExport: handleGetExport
        }
        dispatch(WTPOperationalWorkTableDataAPI({ data }))
    }, [IsPost, isSearch, IsClear,To])
    const { tableData, isLoading } = useSelector(state => state.WTPOperationalWorkTableData)

    const handleGetExport = () => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_WTP_LocationID: LocationName.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: '99999',
        }
        // if (WardName.ID !== 0) {
        dispatch(WTPOperationalWorkTableExportDataAPI({ data }))
        // }
    }
    const { ExporttableData, isExportLoading } = useSelector(state => state.WTPOperationalWorkTableExportData)


    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleDeleteApi = (item) => {
        const data = {
            T_WTP_MaintainanceWork_PreventiveID: item?.t_wtP_MaintainanceWork_PreventiveID,
            M_UserID: UserID,
            handleIsPost: handleIsPost,
            token: token,
        }
        dispatch(WTPOperationalWorkDeleteAPI({ data }))
    }

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                    DashboardName={DashboardName} />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId} />
                    <div className="content">
                        {/* <!-- [ breadcrumb ] start --> */}
                        {/* <!-- [ Main Content ] start --> */}
                        <div className='data_mob'>
                            <div className="row m-1 pb-4 master_border">
                                <div className='mt-2'>
                                    <h5>Operational Work</h5>
                                    <div className="float-end butt">

                                        {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                tableData && tableData.table && tableData.table.length > 0 &&
                                                <WTPPreventiveOperationalWorkExportData
                                                    ExcelData={ExporttableData}
                                                    name='Operational Work'
                                                />
                                        }
                                    </div>
                                </div>
                                <div className="row m-0 pt-1 pb-5">
                                    <div className="col-12 py-0 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12">
                                            <div className="row py-1 rounded2">

                                                <div className="col-12 col-md-6 col-lg-2 ">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"> <b>From Date </b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="FromDate"
                                                            value={FromDate}
                                                            onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                        />

                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-2 ">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"> <b>To Date </b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="FromDate"
                                                            value={ToDate}
                                                            onChange={(e) => setToDate(e.target.value)}
                                                            min={FromDate}
                                                        />

                                                    </div>
                                                </div>

                                                <div className="col-lg-2 col-md-6">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard={HWard}
                                                        WLable={WLable}
                                                    />


                                                </div>

                                                <div className="col-lg-3 col-md-6">
                                                    <WTPLocationMasterDDL
                                                        LocationName={LocationName}
                                                        setLocationName={setLocationName}
                                                        WardName={WardName}
                                                        IsPost={IsPost}
                                                    // Flag='ward'
                                                    />
                                                </div>

                                                <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>

                                            </div>
                                            <div className="row mob_table table-responsive pt-2">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">

                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Date</th>
                                                            <th>Work Name</th>
                                                            <th>Before Photo</th>
                                                            <th>After Photo</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((i) =>
                                                                <tr>
                                                                    <td style={{ textAlign: "center" }}>{i?.rowNum}</td>
                                                                    <td>{i?.workAssignedDate ? moment(i?.workAssignedDate).format('DD-MM-YYYY') : '-'}</td>
                                                                    <td>{i?.workName ? i?.workName : '-'}</td>
                                                                    <td className='text-center'>
                                                                        {
                                                                            (i.beforePhoto == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <>
                                                                                    <i className="fa-solid fa-eye"
                                                                                        style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                        onClick={() => (
                                                                                            handleShowImage(i.beforePhoto),
                                                                                            setHeading("Assign Work Photo")
                                                                                        )}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>
                                                                    <td className='text-center'>
                                                                        {
                                                                            (i.afterPhoto == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <>
                                                                                    <i className="fa-solid fa-eye"
                                                                                        style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                        onClick={() => (
                                                                                            handleShowImage(i.afterPhoto),
                                                                                            setHeading("Assign Work Photo")
                                                                                        )}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            (i.workAssignedDate) == moment().format('DD-MM-YYYY') ?
                                                                                <DeletePopup
                                                                                    open={DeletePopupShow}
                                                                                    item={i}
                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                />
                                                                                :
                                                                                '-'
                                                                        }
                                                                    </td>

                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* {
                    WTPQuantityOfWaterPagePopupShow ?
                        <WTPQuantityOfWaterPagePopup
                            open={WTPQuantityOfWaterPagePopupShow}
                            // handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                        // Flag={apiFlag}
                        // rowData={rowData}
                        />
                        : <></>
                } */}

                </div>
                {
                    showImagePopup ?
                        <ViewURL
                            Heading="Asset Photo"
                            setshowImagePopup={setshowImagePopup}
                            ImagePopUpData={ImagePopUpData}

                        />
                        : ''
                }
            </div>

        </>

    )
}